import { Link } from "react-router-dom";
import projectImg from '../../assets/images/project.png'

export default function Projects(){
    return (
        <section className="projects">
            <h1 className="title">projects</h1>
            <div className="detail">
                <p className="sub-title">Built with Code & Care</p>
                <Link className="view-more">view more</Link>
            </div>
            <div className="category-section">
                <ul className="category-wrapper">
                    <li className="activer-line"></li>
                    <li className="category category-all active">all</li>
                    <li className="category category-completed">completed</li>
                    <li className="category category-miniprojects">mini projects</li>
                </ul>
            </div>
            <div className="projects-wrapper">
                <div className="top-left-boble"></div>
                <div className="bottom-right-boble"></div>
                <div className="project">
                    <div className="detail">
                        <div className="project-title">countdown timer</div>
                        <p className="description">Peshgaman Is A New Project Created Using Modern Technologies And Powerful Tools. Operating In The "News" Sector, This Project Was Designed And Implemented Over A Period Of 3 Months. Utilizing Front-End Languages Such As HTML, CSS, JavaScript, And Bootstrap, Along With Back-End Languages Including Python, Django, And Django Rest Framework, The Project Has Successfully Concluded. It Offers Innovative And Engaging Services To Users</p>
                        <div className="line-wrapper">
                            <hr />
                            <div>
                                <Link className="btn btn-getaproject btn-icon">View Project</Link>
                            </div>
                        </div>
                    </div>
                    <div className="project-img">
                        <div className="img" style={{backgroundImage: `url(${projectImg})`}}></div>
                    </div>
                </div>
                <div className="project">
                    <div className="detail">
                        <div className="project-title">countdown timer</div>
                        <p className="description">Peshgaman Is A New Project Created Using Modern Technologies And Powerful Tools. Operating In The "News" Sector, This Project Was Designed And Implemented Over A Period Of 3 Months. Utilizing Front-End Languages Such As HTML, CSS, JavaScript, And Bootstrap, Along With Back-End Languages Including Python, Django, And Django Rest Framework, The Project Has Successfully Concluded. It Offers Innovative And Engaging Services To Users</p>
                        <div className="line-wrapper">
                            <hr />
                            <div><Link className="btn btn-getaproject btn-icon">View Project 
                            </Link></div>
                        </div>
                    </div>
                    <div className="project-img">
                        <div className="img" style={{backgroundImage: `url(${projectImg})`}}></div>
                    </div>
                </div>
                <div className="project">
                    <div className="detail">
                        <div>    
                            <div className="project-title">countdown timer</div>
                            <p className="description">Peshgaman Is A New Project Created Using Modern Technologies And </p>
                        </div>
                        <div className="line-wrapper">
                            <hr />
                            <div><Link className="btn btn-getaproject btn-icon">View Project 
                            </Link></div>
                        </div>
                    </div>
                    <div className="project-img">
                        <div className="img" style={{backgroundImage: `url(${projectImg})`}}></div>
                    </div>
                </div>
            </div>
            <Link className="view-more">view more</Link>
        </section>
    )
}